import AsyncLoading from "./loader.vue";
export default AsyncLoading;
